import { render, staticRenderFns } from "./QuarterlyAwardsSummary.vue?vue&type=template&id=58771d03&v-if=isLoggedIn&"
import script from "./QuarterlyAwardsSummary.vue?vue&type=script&lang=js&"
export * from "./QuarterlyAwardsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports